import React, { useContext, useEffect, useState } from 'react';
import {
  IRoleProps,
  IRoleSimpleProps,
} from '../../../../services/RoleService/types';
import TableComponent, {
  IColumnProps,
} from '../../../../components/TableComponent';
import ButtonComponent from '../../../../components/ButtonComponent';
import { Add } from '@mui/icons-material';
import ButtonActionsComponent from '../../../../components/ButtonActionsComponent';
import {
  useDeleteRoleAsync,
  useGetAllRoleByLicenseAsync,
  useGetRoleByIdAsync,
} from '../../../../services/RoleService/hooks/useMutation';
import RoleEditionModal from './RoleEditionModal';
import ConfirmDeleteModalComponent from '../../../../components/ConfirmDeleteModalComponent';
import { AppContext } from '../../../../context/AppContextProvider';
import { Box } from '@mui/material';

const RolesManagementTab = () => {
  const [roles, setRoles] = useState<IRoleSimpleProps[]>([]);
  const { showSnackbar } = useContext(AppContext);
  const [isVisibleEditionModal, setIsVisibleEditionModal] =
    useState<boolean>(false);

  const [isVisibleDeleteItemModal, setIsVisibleDeleteItemModal] =
    useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<
    IRoleSimpleProps | IRoleProps
  >();

  const { mutateAsync } = useGetAllRoleByLicenseAsync();
  const { mutateAsync: mutateRoleGetById } = useGetRoleByIdAsync();

  const { mutateAsync: mutateDeleteRoleAsync, isLoading: isLoadingDeleteRole } =
    useDeleteRoleAsync();

  const columns: IColumnProps[] = [
    {
      id: 'name',
      label: 'Nome',
      width: '100%',
    },
    {
      id: 'hexadecimalColor',
      label: 'Cor',
      width: 'min',
      align: 'center',
      render: (id) => (
        <Box
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
          }}
        >
          <Box
            sx={{
              backgroundColor: id,
              width: 20,
              height: 20,
            }}
          ></Box>
        </Box>
      ),
    },
    {
      id: 'id',
      label: 'Ações',
      width: 'min',
      render: (id) => (
        <ButtonActionsComponent
          isWithDefaultOptionsList
          handleDelete={() => handleDeleteItem(Number(id))}
          handleEdit={() => handleEdit(Number(id))}
        />
      ),
    },
  ];

  const handleDeleteItem = (id: number) => {
    setSelectedItem(roles.find((d) => d.id === id));
    setIsVisibleDeleteItemModal(true);
  };

  const handleEdit = (id: number) => {
    mutateRoleGetById(id)
      .then(setSelectedItem)
      .then(() => setIsVisibleEditionModal(true));
  };

  const handleConfirmDeletion = () => {
    if (selectedItem?.id)
      mutateDeleteRoleAsync(selectedItem?.id).then(() => {
        showSnackbar('Cargo excluído com sucesso.', 'success');
        setIsVisibleDeleteItemModal(false);
        reqAll();
      });
  };

  const handleCancelDeletion = () => {
    setIsVisibleDeleteItemModal(false);
    setSelectedItem(undefined);
  };

  const reqAll = () => {
    mutateAsync().then(setRoles);
  };

  const handleSave = () => {
    reqAll();
  };

  useEffect(() => {
    reqAll();
  }, []);

  return (
    <>
      <TableComponent
        additionalTitleComponent={
          <ButtonComponent
            onClick={() => setIsVisibleEditionModal(true)}
            startIcon={<Add />}
          >
            Novo cargo
          </ButtonComponent>
        }
        title="Cargos cadastrados"
        rows={roles}
        columns={columns}
      />
      <ConfirmDeleteModalComponent
        isLoading={isLoadingDeleteRole}
        isVisibleDeleteDialog={isVisibleDeleteItemModal}
        setIsVisibleDeleteDialog={setIsVisibleDeleteItemModal}
        title={'Excluir cargo'}
        message={`Tem certeza que deseja excluir o cargo "${selectedItem?.name}"?`}
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
      />
      <RoleEditionModal
        handleSaveForm={handleSave}
        isOpen={isVisibleEditionModal}
        roleToEdit={selectedItem}
        setIsOpen={setIsVisibleEditionModal}
      />
    </>
  );
};

export default RolesManagementTab;
